import Holidays from 'date-holidays';
import moment from 'moment-timezone';

type CountryCode = 'US';

/**
 * Get the holiday list for a given country code
 * @param countryCode - The country code to get the holiday list for. Default is 'US'
 * @param defaultDate - The default date to get the holiday list for. Default is the current date
 * @param state - The state to get the holiday list for.
 * @returns The holiday list for the given country code. If country code is not supported, it returns an empty array
 */
const getHolidayList = (
  countryCode: CountryCode = 'US',
  defaultDate: string = '',
  state: string = ''
) => {
  const year = moment(defaultDate).format('YYYY');

  const hd = new Holidays(countryCode, {
    types: ['public']
  });

  const holidays = hd.getHolidays(year);

  return holidays.map(h => ({
    date: h.date,
    holidayName: h.name
  }));
};

export default getHolidayList;
